import React, { Fragment, useEffect } from 'react';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Premium from '../premium/Premium';
import { StateModel } from '../../../redux/store';
import { connect } from 'react-redux';

import Hauptmandanten from './mandanten/Hauptmandanten';
import Anzeigestatus from './anzeigestatus/Anzeigestatus';
import Adressenimport from './adressenimport/Adressenimport';
import Info from './info/Info';
import DefaultStatuskette from './defaultstatus/DefaultStatuskette';
import { getSessionCount } from '../../../redux/actions/admin';
import { ConfigModel } from '../../../models/ConfigModel';

interface AdminbereichProps {
  sessionCount: number;
  getSessionCount: () => void;
  config: ConfigModel;
}

/**
 * Adminbereich
 *
 * @returns {JSX.Element} Adminbereich-Component
 * @constructor
 */
const Adminbereich = (props: AdminbereichProps & RouteComponentProps) => {
  const isBexPremium = props.config.isBexPremium;
  let wrapperClass = 'admin-wrapper';
  //#81878 Bex-Premium im Standard ausblenden
  if (!isBexPremium) wrapperClass = 'admin-wrapper-wobp';

  useEffect(() => {
    props.getSessionCount();
  }, []);
  return (
    <Fragment>
      <div className={wrapperClass}>
        <Hauptmandanten />
        <Adressenimport />
        {isBexPremium && (
          <GridCellWrapper classes='premium' label='BEX-Premium-Import'>
            <div id='admin-premium'>
              <Premium onCloseHandler={''} />
            </div>
          </GridCellWrapper>
        )}
        <DefaultStatuskette />
        <Anzeigestatus />
        <Info> </Info>
        <GridCellWrapper classes='nicetohave' label='nice to have'>
          <div className={'nicetohave_content'}>
            <h4>
              <br /> <br />
              Willkommen im Adminbereich
              <br /> <br />
            </h4>
            <span>aktive Sessions: {props.sessionCount}</span>
          </div>
        </GridCellWrapper>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  sessionCount: state.Admin.sessionCount,
  config: state.Config,
});

export default connect(mapStateToProps, {
  getSessionCount,
})(withRouter(Adminbereich));
